import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { RegistrationVerify } from 'src/app/models/registration-verify.model';
import { map } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  private dbPath = 'registraionverify';
  registrationVerifyRef: AngularFirestoreCollection<RegistrationVerify> = null;
  registrationVerify: RegistrationVerify;

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  constructor(private firestore: AngularFirestore, private afAuth: AngularFireAuth, public datePipe: DatePipe) {
    this.registrationVerifyRef = firestore.collection(this.dbPath, ref => ref.orderBy('createdDate', "desc"));
  }

  getRegistrationVerifies() {
    return this.registrationVerifyRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ id: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    );
  }

  createRegistrationVerify(registrationVerify: RegistrationVerify) {
    return this.registrationVerifyRef.add({ ...registrationVerify });
  }

  updateRegistrationVerify(registrationVerify: RegistrationVerify) {
    return this.registrationVerifyRef.doc(registrationVerify.id).update(registrationVerify);
  }

  deletePolicy(registrationVerifyId) {
    return this.registrationVerifyRef.doc(registrationVerifyId).delete();
  }

  deleteMultiPolicy(lstId) {
    for (let i = 0; i < lstId.length; i++) {
      this.registrationVerifyRef.doc(lstId[i]).delete();
    }
  }

  replyMulti(registrationVerifyFeedback, listRegistrationVerify) {
    for (let i = 0; i < listRegistrationVerify.length; i++) {
      let registrationVerify = listRegistrationVerify[i] as RegistrationVerify;
      registrationVerify.verifyName = registrationVerifyFeedback.verifyName;
      registrationVerify.feedbackInformation = registrationVerifyFeedback.feedbackInformation;
      this.registrationVerifyRef.doc(registrationVerify.id).update(registrationVerify);
    }
  }

  getDetailsRegistrationVerify(registrationVerifyId) {
    return this.firestore.doc(this.dbPath + "/" + registrationVerifyId).snapshotChanges();
  }

  search(declarationNumber) {
    return this.firestore.collection('registraionverify', ref => ref.where('declarationNumber', '==', declarationNumber).orderBy('createdDate', "desc")).snapshotChanges().pipe
      (map(list => {
        return list.map(item => {
          return { id: item.payload.doc.id, ...item.payload.doc.data() as RegistrationVerify };
        })
      }));
  }

  getEmailsAdmin() {
    return environment.listGmail;
  }

  exportExcel(jsonData: any[], fileName: string): void {
    delete jsonData['id'];
    let newJsonData = jsonData.map(data => {
      return {
        'Ngày dự kiến xuất trình hàng': data.expectedDeliveryDate,
        'Giờ dự kiến xuất trình hàng': data.expectedDeliveryHour,
        'Số tờ khai': data.declarationNumber,
        'Mã loại hình': data.codeType,
        'Tên doanh nghiệp': data.enterpriseName,
        'Tên hàng hóa': data.productName,
        'Số lượng': data.countProduct,
        'Địa điểm kiểm tra thực tế hàng hóa': data.address,
        'Người nhận': data.receiverName,
        'Sđt người nhận': data.receiverPhone,
        'Phân công kiểm hóa viên': data.verifyName,
        'Phản hồi thông tin tới DN': data.feedbackInformation,
        'Ngày đăng ký kiểm hóa': this.datePipe.transform(data.createdDate, 'dd/MM/yyyy HH:mm:ss')
      }
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newJsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'danh-sach-dang-ky-kiem-hoa': ws }, SheetNames: ['danh-sach-dang-ky-kiem-hoa'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }
}
